<template>
  <div class="iframe-container">
    <!-- 1. 添加 ref 属性，用于在脚本中获取iframe元素 -->
    <iframe
      ref="subAppIframe"
      :src="iframeSrc"
      frameborder="0"
      class="iframe-page"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      iframeSrc: 'http://58.213.48.54:12345/index' //正式
      // iframeSrc: 'http://58.213.48.52:55845/index' //测试
    }
  },
  mounted() {
    // 2. 在组件挂载后执行
    this.sendTokenToIframe();
  },
  methods: {
    // 封装发送token的逻辑
    sendTokenToIframe() {
      // --- 辅助函数：从document.cookie中读取指定名称的值 ---
      const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
      };

      // --- 获取需要传递的token值 ---
      const dnnypt_checkCode = getCookie('dnnypt_checkCode');
      const dnnypt_token = getCookie('dnnypt_token');
      this.iframeSrc += `?checkCode=${dnnypt_checkCode}&token=${dnnypt_token}`;
      console.log('this.iframeSrc', this.iframeSrc);
    }
  }
}
</script>

<style lang="scss" scoped>
.iframe-container {
  width: 100%;
  height: calc(100vh - 0px);
  overflow: hidden;
}

.iframe-page {
  width: 100%;
  height: 100%;
  border: none;
}
</style>


// WEBPACK FOOTER //
// IframePage.vue?7881c4d6